import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { IconNames } from '@shared/enums/icon-names';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-secret-number-message',
  templateUrl: './secret-number-message.component.html',
  styleUrls: ['./secret-number-message.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatIcon, MatDialogActions, IceButtonComponent, MatDialogClose],
})
export class SecretNumberMessageComponent {
  dialogRef = inject<MatDialogRef<SecretNumberMessageComponent>>(MatDialogRef);

  IconNames = IconNames;
}
